import { useLocation } from 'react-router';

import { HomeownerAppMenuNames } from '../providers/HomeownerAppProvider';

import { useHomeownerAppContext } from '.';

export const useUploadFailure = () => {
  const location = useLocation();

  const homeownerAppContext = useHomeownerAppContext();

  const uploadErrorMessage = (location.state as { uploadErrorMessage?: string })
    ?.uploadErrorMessage;

  if (uploadErrorMessage) {
    homeownerAppContext.setCurrentMenu(HomeownerAppMenuNames.UPLOAD_PHOTO);
  }
};
